export const LoadingAnimated = () => {
	return (
		<div className='w-full h-screen flex flex-col justify-center items-center'>
			<img src='/img/LoadingGraph.gif' alt='loading...' className='w-96'></img>
		</div>
	);
};
